//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AccountTaxRate, AdjustBalanceResult, AdjustBuyerCreditInput, BatchUpsertAccountTaxRatesRequest, BuyerCreditDto, BuyerDetailDto, BuyerPaymentMethodsResponse, BuyerUpsertDto, FileParameter, ImportAccountTaxRatesResponse, PagedSellerBuyersWithSalesResult, SellerBuyersOrderBy, SortDirection } from './types';


export interface IAccountTaxRateClient {

    getRules(): Promise<AccountTaxRate[]>;

    batchUpsertRules(request: BatchUpsertAccountTaxRatesRequest): Promise<boolean>;

    deleteRule(id: number | undefined): Promise<boolean>;

    getTaxRateByLocation(countryCode: string | null | undefined, stateProvince: string | null | undefined, zipCode: string | null | undefined): Promise<number>;

    importRules(file: FileParameter | null | undefined): Promise<ImportAccountTaxRatesResponse>;
}

export class AccountTaxRateClient extends PosClientBase implements IAccountTaxRateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRules(signal?: AbortSignal | undefined): Promise<AccountTaxRate[]> {
        let url_ = this.baseUrl + "/api/AccountTaxRate/GetRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRules(_response);
        });
    }

    protected processGetRules(response: Response): Promise<AccountTaxRate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountTaxRate[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountTaxRate[]>(null as any);
    }

    batchUpsertRules(request: BatchUpsertAccountTaxRatesRequest, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AccountTaxRate/BatchUpsertRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchUpsertRules(_response);
        });
    }

    protected processBatchUpsertRules(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteRule(id: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AccountTaxRate/DeleteRule?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRule(_response);
        });
    }

    protected processDeleteRule(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getTaxRateByLocation(countryCode: string | null | undefined, stateProvince: string | null | undefined, zipCode: string | null | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AccountTaxRate/GetTaxRateByLocation?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (stateProvince !== undefined && stateProvince !== null)
            url_ += "stateProvince=" + encodeURIComponent("" + stateProvince) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "zipCode=" + encodeURIComponent("" + zipCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaxRateByLocation(_response);
        });
    }

    protected processGetTaxRateByLocation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    importRules(file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ImportAccountTaxRatesResponse> {
        let url_ = this.baseUrl + "/api/AccountTaxRate/ImportRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportRules(_response);
        });
    }

    protected processImportRules(response: Response): Promise<ImportAccountTaxRatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportAccountTaxRatesResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportAccountTaxRatesResponse>(null as any);
    }
}
export interface IRetailClient {

    getBuyerDetailByEmail(buyerEmail: string | undefined): Promise<BuyerDetailDto | null>;

    getSellerBuyersPaginated(pageSize: number | undefined, pageNumber: number | undefined, orderBy: SellerBuyersOrderBy | undefined, orderDirection: SortDirection | undefined, lastRetailActivityDateFrom: string | null | undefined, lastRetailActivityDateTo: string | null | undefined, buyerName: string | null | undefined): Promise<PagedSellerBuyersWithSalesResult>;

    getBuyerPaymentMethods(buyerEmail: string | undefined): Promise<BuyerPaymentMethodsResponse[]>;

    upsertBuyer(buyerUpsert: BuyerUpsertDto, isNewBuyer: boolean | undefined): Promise<boolean>;

    getBuyerCredit(buyerEmail: string | undefined, targetCurrency: string | null | undefined): Promise<BuyerCreditDto>;

    adjustBuyerCredit(input: AdjustBuyerCreditInput): Promise<AdjustBalanceResult>;
}

export class RetailClient extends PosClientBase implements IRetailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBuyerDetailByEmail(buyerEmail: string | undefined, signal?: AbortSignal | undefined): Promise<BuyerDetailDto | null> {
        let url_ = this.baseUrl + "/api/Retail/GetBuyerDetailByEmail?";
        if (buyerEmail === null)
            throw new Error("The parameter 'buyerEmail' cannot be null.");
        else if (buyerEmail !== undefined)
            url_ += "buyerEmail=" + encodeURIComponent("" + buyerEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuyerDetailByEmail(_response);
        });
    }

    protected processGetBuyerDetailByEmail(response: Response): Promise<BuyerDetailDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuyerDetailDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BuyerDetailDto | null>(null as any);
    }

    getSellerBuyersPaginated(pageSize: number | undefined, pageNumber: number | undefined, orderBy: SellerBuyersOrderBy | undefined, orderDirection: SortDirection | undefined, lastRetailActivityDateFrom: string | null | undefined, lastRetailActivityDateTo: string | null | undefined, buyerName: string | null | undefined, signal?: AbortSignal | undefined): Promise<PagedSellerBuyersWithSalesResult> {
        let url_ = this.baseUrl + "/api/Retail/GetSellerBuyersPaginated?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (lastRetailActivityDateFrom !== undefined && lastRetailActivityDateFrom !== null)
            url_ += "LastRetailActivityDateFrom=" + encodeURIComponent("" + lastRetailActivityDateFrom) + "&";
        if (lastRetailActivityDateTo !== undefined && lastRetailActivityDateTo !== null)
            url_ += "LastRetailActivityDateTo=" + encodeURIComponent("" + lastRetailActivityDateTo) + "&";
        if (buyerName !== undefined && buyerName !== null)
            url_ += "BuyerName=" + encodeURIComponent("" + buyerName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerBuyersPaginated(_response);
        });
    }

    protected processGetSellerBuyersPaginated(response: Response): Promise<PagedSellerBuyersWithSalesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedSellerBuyersWithSalesResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedSellerBuyersWithSalesResult>(null as any);
    }

    getBuyerPaymentMethods(buyerEmail: string | undefined, signal?: AbortSignal | undefined): Promise<BuyerPaymentMethodsResponse[]> {
        let url_ = this.baseUrl + "/api/Retail/GetBuyerPaymentMethods?";
        if (buyerEmail === null)
            throw new Error("The parameter 'buyerEmail' cannot be null.");
        else if (buyerEmail !== undefined)
            url_ += "buyerEmail=" + encodeURIComponent("" + buyerEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuyerPaymentMethods(_response);
        });
    }

    protected processGetBuyerPaymentMethods(response: Response): Promise<BuyerPaymentMethodsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuyerPaymentMethodsResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BuyerPaymentMethodsResponse[]>(null as any);
    }

    upsertBuyer(buyerUpsert: BuyerUpsertDto, isNewBuyer: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Retail/UpsertBuyer?";
        if (isNewBuyer === null)
            throw new Error("The parameter 'isNewBuyer' cannot be null.");
        else if (isNewBuyer !== undefined)
            url_ += "isNewBuyer=" + encodeURIComponent("" + isNewBuyer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(buyerUpsert);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertBuyer(_response);
        });
    }

    protected processUpsertBuyer(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getBuyerCredit(buyerEmail: string | undefined, targetCurrency: string | null | undefined, signal?: AbortSignal | undefined): Promise<BuyerCreditDto> {
        let url_ = this.baseUrl + "/api/Retail/GetBuyerCredit?";
        if (buyerEmail === null)
            throw new Error("The parameter 'buyerEmail' cannot be null.");
        else if (buyerEmail !== undefined)
            url_ += "buyerEmail=" + encodeURIComponent("" + buyerEmail) + "&";
        if (targetCurrency !== undefined && targetCurrency !== null)
            url_ += "targetCurrency=" + encodeURIComponent("" + targetCurrency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuyerCredit(_response);
        });
    }

    protected processGetBuyerCredit(response: Response): Promise<BuyerCreditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuyerCreditDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BuyerCreditDto>(null as any);
    }

    adjustBuyerCredit(input: AdjustBuyerCreditInput, signal?: AbortSignal | undefined): Promise<AdjustBalanceResult> {
        let url_ = this.baseUrl + "/api/Retail/AdjustBuyerCredit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdjustBuyerCredit(_response);
        });
    }

    protected processAdjustBuyerCredit(response: Response): Promise<AdjustBalanceResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdjustBalanceResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdjustBalanceResult>(null as any);
    }
}
